import { render, staticRenderFns } from "./AddPhotoBtn.vue?vue&type=template&id=1e50e154&scoped=true&"
import script from "./AddPhotoBtn.vue?vue&type=script&lang=js&"
export * from "./AddPhotoBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddPhotoBtn.vue?vue&type=style&index=0&id=1e50e154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50e154",
  null
  
)

export default component.exports